module.exports = __webpack_public_path__ + "static/media/newspaper_example.2cd90caf.png";